import { useState } from "react";
import { CheckCheck, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { usePresence, activeLabel } from "../lib/presence";

export const ActiveText = ({ username }) => {
  const label = activeLabel(usePresence(username));
  if (!label) return null;
  return <span data-testid="profile-active-status" className={`ml-2 ${label === "Active now" ? "text-[#31A24C]" : "text-[#71717A]"}`}>· {label}</span>;
};

export const ActivityToggle = ({ user, setUser }) => {
  const [busy, setBusy] = useState(false);
  const on = user?.show_activity !== false;
  const flip = async () => {
    setBusy(true);
    try {
      await api.put("/me/activity-status", { value: !on });
      setUser?.((u) => ({ ...u, show_activity: !on }));
      toast.success(!on ? "Activity status is visible" : "Activity status hidden");
    } catch { toast.error("Could not update"); }
    setBusy(false);
  };
  return (
    <button data-testid="activity-status-toggle" onClick={flip} disabled={busy}
      className="flex items-center gap-2 border border-white/10 text-[#9CA3AF] font-semibold text-sm px-4 py-2.5 rounded-lg hover:text-white transition-colors disabled:opacity-50">
      <span className={`w-2.5 h-2.5 rounded-full ${on ? "bg-[#31A24C] shadow-[0_0_8px_rgba(49,162,76,0.8)]" : "bg-[#52525B]"}`} />
      {on ? "Activity: on" : "Activity: off"}
    </button>
  );
};

const fmt = (iso) => new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const ReadReceipt = ({ msg, reads, group }) => {
  const seen = (reads || []).filter((r) => r.last_read_at && r.last_read_at >= msg.created_at);
  if (!seen.length) {
    return <span data-testid="read-receipt" className="flex items-center gap-1 text-[10px] text-[#64748B] mt-0.5 px-1"><Check size={11} /> Delivered</span>;
  }
  const latest = seen.map((r) => r.last_read_at).sort().pop();
  return (
    <span data-testid="read-receipt" className="flex items-center gap-1 text-[10px] text-[#00E5FF] mt-0.5 px-1">
      <CheckCheck size={11} /> {group ? `Seen by ${seen.length}` : "Seen"} · {fmt(latest)}
    </span>
  );
};
